import type { PolygonData } from "@/providers/maps/types";

function readNestedProperties(
  properties: Record<string, unknown>,
): Record<string, unknown> {
  const nested = properties.properties;

  if (typeof nested === "string") {
    try {
      const parsed = JSON.parse(nested) as Record<string, unknown>;
      return typeof parsed === "object" && parsed != null ? parsed : properties;
    } catch {
      return properties;
    }
  }

  if (typeof nested === "object" && nested != null) {
    return nested as Record<string, unknown>;
  }

  return properties;
}

export function propertyIdToString(value: unknown): string {
  if (value == null) {
    return "";
  }

  if (typeof value === "string") {
    return value.trim();
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  return "";
}

export function readPreviewBoundaryFeatureProperties(
  properties: Record<string, unknown> | undefined,
): Record<string, unknown> {
  if (!properties) {
    return {};
  }

  return readNestedProperties(properties);
}

export function getPreviewBoundarySchoolId(
  properties: Record<string, unknown> | undefined,
): string | null {
  const resolved = readPreviewBoundaryFeatureProperties(properties);
  const schoolId = propertyIdToString(resolved.schoolId);

  return schoolId || null;
}

export function parsePreviewBoundaryFeatureIds(
  polygon: PolygonData,
): { previewId: string; documentId: string } | null {
  const raw = (polygon.properties ?? {}) as Record<string, unknown>;
  const properties = readNestedProperties(raw);

  const previewId =
    propertyIdToString(properties.boundaryId) ||
    propertyIdToString(properties.previewId) ||
    propertyIdToString(polygon.id);
  const documentId = propertyIdToString(properties.documentId);

  if (!previewId || !documentId) {
    return null;
  }

  return { previewId, documentId };
}
